import React from "react";
import { HiOutlineExternalLink } from "react-icons/hi";
import {
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaYoutube,
  FaTiktok,
  FaWhatsapp,
  FaTelegram,
  FaSnapchat,
  FaDiscord,
  FaPinterest,
  FaReddit,
  FaSignal,
  FaSpotify,
  FaApple,
  FaGooglePlay,
  FaTwitch,
  FaMedium,
  FaPatreon,
  FaSlack,
  FaGithub,
  FaGitlab,
  FaBitbucket,
  FaStackOverflow,
  FaDribbble,
  FaBehance,
  FaFigma,
  FaSketch,
  FaAmazon,
  FaEbay,
  FaEtsy,
  FaShopify,
  FaPaypal,
  FaStripe,
  FaGamepad,
} from "react-icons/fa6";
import {
  SiGooglemaps,
  SiWaze,
  SiNotion,
  SiTrello,
  SiAsana,
  SiMicrosoft,
  SiGoogle,
  SiZoom,
  SiSkype,
  SiDropbox,
  SiNetflix,
  SiPrime,
  SiHulu,
  SiHbo,
  SiSoundcloud,
  SiApplemusic,
  SiDeezer,
  SiPandora,
  SiAdobe,
  SiCashapp,
  SiGoogledrive,
} from "react-icons/si";
import {
  BiCart,
  BiCoffee,
  BiRestaurant,
  BiCar,
  BiHome,
  BiPhone,
  BiEnvelope,
  BiGlobe,
  BiBuilding,
  BiPalette,
  BiCut,
  BiDumbbell,
  BiHealth,
  BiWrench,
  BiMoney,
  BiTrophy,
  BiMap,
  BiCalendar,
  BiStar,
  BiSolidStar,
  BiHeart,
  BiTime,
  BiUser,
  BiBook,
  BiMusic,
  BiCamera,
  BiSupport,
  BiDownload,
  BiCloudDownload,
  BiShield,
  BiCog,
  BiNews,
  BiLaptop,
  BiWifi,
  BiPrinter,
  BiMessageDetail,
  BiVideo,
  BiGift,
  BiSolidPizza,
  BiDrink,
  BiBriefcase,
  BiPackage,
  BiLeaf,
  BiLock,
  BiPlay,
  BiMicrophone,
  BiHeadphone,
  BiMoviePlay,
  BiCreditCard,
  BiWallet,
  BiBarChart,
  BiPieChart,
  BiLineChart,
  BiFootball,
  BiRun,
  BiPencil,
  BiBrush,
  BiRocket,
  BiCodeAlt,
  BiTerminal,
  BiServer,
  BiMobileAlt,
  BiDesktop,
  BiBell,
  BiAlarm,
  BiSun,
  BiMoon,
  BiFirstAid,
  BiClinic,
  BiLogoVenmo,
} from "react-icons/bi";
import { BsShop } from "react-icons/bs";
import { CiPill } from "react-icons/ci";
import { TbBrandDisney, TbBrandOnedrive } from "react-icons/tb";

interface LinkItem {
  icontype?: string;
  icon?: string;
  [key: string]: any;
}

export const getLinkIcon = (
  link: LinkItem,
  fallbackColor = "text-gray-500"
) => {
  const { icontype, icon } = link;

  if (!icon)
    return <HiOutlineExternalLink className={`w-4 h-4 ${fallbackColor}`} />;

  if (icontype === "url") {
    return (
      <div className={`relative w-4 h-4 flex items-center justify-center`}>
        <img
          src={icon}
          alt="Custom icon"
          className={`w-4 h-4 object-contain rounded`}
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = "none";
            const fallback = target.parentElement?.querySelector(
              ".fallback-icon"
            ) as HTMLElement;
            if (fallback) fallback.style.display = "block";
          }}
          onLoad={(e) => {
            const target = e.target as HTMLImageElement;
            const fallback = target.parentElement?.querySelector(
              ".fallback-icon"
            ) as HTMLElement;
            if (fallback) fallback.style.display = "none";
          }}
        />
        <HiOutlineExternalLink
          className={`fallback-icon w-4 h-4 ${fallbackColor} absolute inset-0`}
          style={{ display: "none" }}
        />
      </div>
    );
  }

  const iconMap: { [key: string]: React.ReactNode } = {
    instagram: <FaInstagram className="w-4 h-4 text-pink-500" />, // design-ok: charte de marque, rose Instagram
    facebook: <FaFacebook className="w-4 h-4 text-blue-600" />,
    twitter: <FaTwitter className="w-4 h-4 text-black" />,
    linkedin: <FaLinkedin className="w-4 h-4 text-blue-700" />,
    youtube: <FaYoutube className="w-4 h-4 text-red-600" />,
    tiktok: <FaTiktok className="w-4 h-4 text-gray-800" />,
    whatsapp: <FaWhatsapp className="w-4 h-4 text-green-500" />,
    telegram: <FaTelegram className="w-4 h-4 text-blue-500" />,
    snapchat: <FaSnapchat className="w-4 h-4 text-yellow-400" />, // design-ok: charte de marque, jaune Snapchat
    discord: <FaDiscord className="w-4 h-4 text-indigo-500" />, // design-ok: charte de marque, blurple Discord
    pinterest: <FaPinterest className="w-4 h-4 text-red-500" />,
    reddit: <FaReddit className="w-4 h-4 text-orange-500" />, // design-ok: charte de marque, orange Reddit
    signal: <FaSignal className="w-4 h-4 text-blue-500" />,
    spotify: <FaSpotify className="w-4 h-4 text-green-500" />,
    twitch: <FaTwitch className="w-4 h-4 text-purple-600" />,
    medium: <FaMedium className="w-4 h-4 text-gray-800" />,
    patreon: <FaPatreon className="w-4 h-4 text-orange-600" />, // design-ok: charte de marque, corail Patreon
    slack: <FaSlack className="w-4 h-4 text-purple-500" />,
    github: <FaGithub className="w-4 h-4 text-gray-800" />,
    gitlab: <FaGitlab className="w-4 h-4 text-orange-600" />, // design-ok: charte de marque, orange GitLab
    bitbucket: <FaBitbucket className="w-4 h-4 text-blue-600" />,
    stackoverflow: <FaStackOverflow className="w-4 h-4 text-orange-500" />, // design-ok: charte de marque, orange Stack Overflow
    dribbble: <FaDribbble className="w-4 h-4 text-pink-500" />, // design-ok: charte de marque, rose Dribbble
    behance: <FaBehance className="w-4 h-4 text-blue-600" />,

    shop: <BsShop className="w-4 h-4 text-purple-500" />,
    cart: <BiCart className="w-4 h-4 text-amber-500" />,
    coffee: <BiCoffee className="w-4 h-4 text-amber-600" />,
    restaurant: <BiRestaurant className="w-4 h-4 text-red-500" />,
    car: <BiCar className="w-4 h-4 text-gray-600" />,
    home: <BiHome className="w-4 h-4 text-green-600" />,
    building: <BiBuilding className="w-4 h-4 text-blue-600" />,
    palette: <BiPalette className="w-4 h-4 text-purple-500" />,
    cut: <BiCut className="w-4 h-4 text-purple-600" />,
    dumbbell: <BiDumbbell className="w-4 h-4 text-red-600" />,
    health: <BiHealth className="w-4 h-4 text-green-500" />,
    wrench: <BiWrench className="w-4 h-4 text-gray-700" />,
    money: <BiMoney className="w-4 h-4 text-green-700" />,
    trophy: <BiTrophy className="w-4 h-4 text-amber-500" />,
    pizza: <BiSolidPizza className="w-4 h-4 text-amber-600" />,
    drink: <BiDrink className="w-4 h-4 text-blue-500" />,
    gift: <BiGift className="w-4 h-4 text-red-500" />,
    briefcase: <BiBriefcase className="w-4 h-4 text-gray-700" />,
    package: <BiPackage className="w-4 h-4 text-amber-600" />,
    leaf: <BiLeaf className="w-4 h-4 text-green-600" />,
    firstaid: <BiFirstAid className="w-4 h-4 text-red-600" />,
    clinic: <BiClinic className="w-4 h-4 text-blue-600" />,
    pill: <CiPill className="w-4 h-4 text-purple-500" />,
    creditcard: <BiCreditCard className="w-4 h-4 text-blue-700" />,
    wallet: <BiWallet className="w-4 h-4 text-gray-600" />,
    barchart: <BiBarChart className="w-4 h-4 text-blue-600" />,
    piechart: <BiPieChart className="w-4 h-4 text-green-600" />,
    linechart: <BiLineChart className="w-4 h-4 text-purple-600" />,
    figma: <FaFigma className="w-4 h-4 text-purple-500" />,
    sketch: <FaSketch className="w-4 h-4 text-orange-500" />, // design-ok: charte de marque, orange Sketch
    adobe: <SiAdobe className="w-4 h-4 text-red-600" />,
    amazon: <FaAmazon className="w-4 h-4 text-orange-500" />, // design-ok: charte de marque, orange Amazon
    ebay: <FaEbay className="w-4 h-4 text-blue-600" />,
    etsy: <FaEtsy className="w-4 h-4 text-orange-600" />, // design-ok: charte de marque, orange Etsy
    shopify: <FaShopify className="w-4 h-4 text-green-600" />,
    paypal: <FaPaypal className="w-4 h-4 text-blue-600" />,
    stripe: <FaStripe className="w-4 h-4 text-purple-600" />,
    venmo: <BiLogoVenmo className="w-4 h-4 text-blue-500" />,
    cashapp: <SiCashapp className="w-4 h-4 text-green-500" />,

    sms: <BiMessageDetail className="w-4 h-4 text-green-500" />,
    website: <BiGlobe className="w-4 h-4 text-blue-500" />,
    googlemaps: <SiGooglemaps className="w-4 h-4 text-green-600" />,
    waze: <SiWaze className="w-4 h-4 text-blue-500" />,
    phone: <BiPhone className="w-4 h-4 text-blue-600" />,
    email: <BiEnvelope className="w-4 h-4 text-red-500" />,
    location: <BiMap className="w-4 h-4 text-red-500" />,
    calendar: <BiCalendar className="w-4 h-4 text-blue-600" />,
    star: <BiStar className="w-4 h-4 text-amber-400" />,
    starfilled: <BiSolidStar className="w-4 h-4 text-amber-400" />,
    heart: <BiHeart className="w-4 h-4 text-red-500" />,
    time: <BiTime className="w-4 h-4 text-blue-500" />,
    user: <BiUser className="w-4 h-4 text-gray-600" />,
    book: <BiBook className="w-4 h-4 text-blue-500" />,
    music: <BiMusic className="w-4 h-4 text-purple-500" />,
    camera: <BiCamera className="w-4 h-4 text-gray-700" />,
    support: <BiSupport className="w-4 h-4 text-green-600" />,
    download: <BiDownload className="w-4 h-4 text-blue-700" />,
    cloud: <BiCloudDownload className="w-4 h-4 text-blue-500" />,
    shield: <BiShield className="w-4 h-4 text-green-700" />,
    settings: <BiCog className="w-4 h-4 text-gray-600" />,
    news: <BiNews className="w-4 h-4 text-blue-600" />,
    laptop: <BiLaptop className="w-4 h-4 text-gray-700" />,
    wifi: <BiWifi className="w-4 h-4 text-blue-500" />,
    print: <BiPrinter className="w-4 h-4 text-gray-600" />,
    video: <BiVideo className="w-4 h-4 text-purple-600" />,
    lock: <BiLock className="w-4 h-4 text-gray-700" />,
    play: <BiPlay className="w-4 h-4 text-green-500" />,
    microphone: <BiMicrophone className="w-4 h-4 text-red-500" />,
    headphone: <BiHeadphone className="w-4 h-4 text-blue-600" />,
    movie: <BiMoviePlay className="w-4 h-4 text-purple-700" />,
    gamepad: <FaGamepad className="w-4 h-4 text-purple-600" />,
    football: <BiFootball className="w-4 h-4 text-green-700" />,
    run: <BiRun className="w-4 h-4 text-blue-600" />,
    pencil: <BiPencil className="w-4 h-4 text-gray-700" />,
    brush: <BiBrush className="w-4 h-4 text-purple-600" />,
    rocket: <BiRocket className="w-4 h-4 text-red-600" />,
    code: <BiCodeAlt className="w-4 h-4 text-blue-600" />,
    terminal: <BiTerminal className="w-4 h-4 text-gray-800" />,
    server: <BiServer className="w-4 h-4 text-gray-700" />,
    mobile: <BiMobileAlt className="w-4 h-4 text-gray-700" />,
    desktop: <BiDesktop className="w-4 h-4 text-gray-700" />,
    bell: <BiBell className="w-4 h-4 text-amber-500" />,
    alarm: <BiAlarm className="w-4 h-4 text-red-500" />,
    sun: <BiSun className="w-4 h-4 text-amber-500" />,
    moon: <BiMoon className="w-4 h-4 text-blue-500" />,
    appstore: <FaApple className="w-4 h-4 text-gray-800" />,
    googleplay: <FaGooglePlay className="w-4 h-4 text-blue-600" />,
    notion: <SiNotion className="w-4 h-4 text-gray-800" />,
    trello: <SiTrello className="w-4 h-4 text-blue-600" />,
    asana: <SiAsana className="w-4 h-4 text-red-500" />,
    microsoft: <SiMicrosoft className="w-4 h-4 text-blue-600" />,
    google: <SiGoogle className="w-4 h-4 text-blue-600" />,
    zoom: <SiZoom className="w-4 h-4 text-blue-600" />,
    skype: <SiSkype className="w-4 h-4 text-blue-500" />,
    dropbox: <SiDropbox className="w-4 h-4 text-blue-600" />,
    onedrive: <TbBrandOnedrive className="w-4 h-4 text-blue-600" />,
    googledrive: <SiGoogledrive className="w-4 h-4 text-yellow-500" />, // design-ok: charte de marque, jaune Google Drive
    netflix: <SiNetflix className="w-4 h-4 text-red-600" />,
    prime: <SiPrime className="w-4 h-4 text-blue-500" />,
    hulu: <SiHulu className="w-4 h-4 text-green-500" />,
    disney: <TbBrandDisney className="w-4 h-4 text-blue-600" />,
    hbo: <SiHbo className="w-4 h-4 text-purple-600" />,
    soundcloud: <SiSoundcloud className="w-4 h-4 text-orange-500" />, // design-ok: charte de marque, orange SoundCloud
    applemusic: <SiApplemusic className="w-4 h-4 text-red-500" />,
    deezer: <SiDeezer className="w-4 h-4 text-purple-500" />,
    pandora: <SiPandora className="w-4 h-4 text-blue-600" />,
  };

  return (
    iconMap[icon] || (
      <HiOutlineExternalLink className={`w-4 h-4 ${fallbackColor}`} />
    )
  );
};
